import { render } from "./PbxDashboardOutbound.vue?vue&type=template&id=69b8f642"
import script from "./PbxDashboardOutbound.vue?vue&type=script&lang=js"
export * from "./PbxDashboardOutbound.vue?vue&type=script&lang=js"

import "./PbxDashboardOutbound.vue?vue&type=style&index=0&id=69b8f642&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__